import { render, staticRenderFns } from "./constructorModal.vue?vue&type=template&id=3ba05715&"
import script from "./constructorModal.vue?vue&type=script&lang=js&"
export * from "./constructorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports